/**************************************************
 * Nombre:       Formulario_Programa
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Espacio = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen Principal de 640px por 400px (fondo transparente) de menos
                        de 300K de
                        peso</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={20} ancho={32} {...props}  />
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Nombre de la escuela'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Descripcion corta de la escuela'}
                                  dato={'descripcion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Justificacion de los programas que la conforman'}
                                  dato={'justificacion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Espacio